import React from 'react';
import { Carousel } from 'primereact/carousel';
import CarouselImage from './CarouselImage';
import '../style.css';

const ShopHeaderRight = ({ storeImages = [], shopName }) => {
  // Carousel responsive options
  const responsiveOptions = [
    { breakpoint: '1400px', numVisible: 1, numScroll: 1 },
    { breakpoint: '1199px', numVisible: 1, numScroll: 1 },
    { breakpoint: '767px', numVisible: 1, numScroll: 1 },
    { breakpoint: '575px', numVisible: 1, numScroll: 1 }
  ];

  // Carousel image template
  const imageTemplate = (item) => <CarouselImage item={item} shopName={shopName} />;

  if (!storeImages || storeImages.length === 0) {
    // No images: show a placeholder card
    return (
    <></>
    );
  }

  if (storeImages.length === 1) {
    // Single image: show a card with the image (not carousel)
    return (
      <div className="shop-header-right">
        <CarouselImage item={storeImages[0]} shopName={shopName} />
      </div>
    );
  }

  // Multiple images: show a carousel
  return (
    <div className="shop-header-right">
      <Carousel
        value={storeImages}
        itemTemplate={imageTemplate}
        numVisible={1}
        numScroll={1}
        circular
        showIndicators={storeImages.length > 1}
        showNavigators={storeImages.length > 1}
        responsiveOptions={responsiveOptions}
        className="shop-image-carousel"
      />
    </div>
  );
};

export default ShopHeaderRight;
